import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { makeStyles } from '@material-ui/styles';
import { Typography, Link, Container, Theme } from '@material-ui/core';

import { Seo, Lazy, Hero } from '../components';
import { FC } from '../util';
import HeroWImage from '../components/hero/heroWImage';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        marginTop: theme.spacing(8),
        marginBottom: theme.spacing(2),
        flexFlow: 'column'
    },
    link: {
        color: theme.palette.text.secondary,
        textDecoration: 'underline'
    },
    heroButtons: {
        maxWidth: '50%'
    },
    imageDiv: {
        textAlign: 'center'
    },
    allTheWay: {
        flewGrow: 1
    }
}));

const PageTwo: FC = () => {
    const styles = useStyles();
    return (
        <Lazy type="fade" delay={500} timeout={1000}>
            <div className="allTheWay">
                <HeroWImage
                    title="SLS Water is the professional choice!"
                    description="SLS Water is the professional choice for your water purification system solution, be it at home or on industrial premises. In business for eleven years, we have been concentrating solely on water purification, which makes us experts on our products, making us the best choice for this product. Our after-sales service makes us reliable as we promise to make sure that everything is repaired as efficiently as possible. As part of our services we also offer deliveries and installations all over Malta and Gozo, and make sure to meet the agreed delivery dates."
                ></HeroWImage>
            </div>
        </Lazy>
    );
};

export default PageTwo;
